import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { useState, useEffect } from 'react';
import InputField from './InputField';
import { addFlashMessage } from '../Actions/FlashMessages.action';
import { get, post } from '../Services/http';
import { catchErrorNoDispatch } from '../Actions/Error.action';
import { handleApiErrors } from '../Services/Error.service';

const MyAccountMySubscriptionsManageSubScription = ({ onToggleManageSubscriptionMode }) => {
    const dispatch = useDispatch();
    const { payload } = useSelector((state) => state.myAccountMySubscriptions);

    const [currentSubscriptionProduct, setCurrentSubscriptionProduct] = useState({});
    const [selectedSubscriptionProduct, setSelectedSubscriptionProduct] = useState({});

    const [isInCancelSubscriptionMode, setIsInCancelSubscriptionMode] = useState(false);
    const [errors, setErrors] = useState([]);

    const [showAfterChangeMessage, setShowAfterChangeMessage] = useState(false);
    const [isChanging, setIsChanging] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [requestUserConfirmation, setRequestUserConfirmation] = useState(false);
    const [onConfirm, setonConfirm] = useState({});

    useEffect(() => {
        if (!payload || payload.allSubscriptionProducts.length === 0) {
            return;
        }
        const current = payload.allSubscriptionProducts.find(x => x.isCustomersCurrentSubscription)
        setCurrentSubscriptionProduct(current);
        setSelectedSubscriptionProduct(current ?? null);
    }, [payload?.allSubscriptionProducts])

    const resetConfirmActionState = () => ({
            callback: null,
            isInCancelMode: false,
    });

    const handleRequestUserConfirmation = (callback, isInCancelMode) => {
        setRequestUserConfirmation(true);
        setonConfirm({callback, isInCancelMode});
    }

    const handleCancelConfirm = () => {
        setRequestUserConfirmation(false);
        if (onConfirm?.isInCancelMode) {
            onToggleManageSubscriptionMode();
        }
        setSelectedSubscriptionProduct(currentSubscriptionProduct);
        setonConfirm(resetConfirmActionState());
    }

    const cancelSubscription = async () => {
        if (!payload?.currentOrLatestSubscriptionInfoId) {
            try {
                await post(
                '/api/flashmessage/add/', 
                { 
                    messageText: translate('js.myaccountflowsubscriptions.managesubscription.cancel.errortext'), 
                    messageType: "Pink", 
                    dismissible: true, 
                    timeToLive: 10 
                });
            } catch (ex) {
            } finally {
                window.scrollTo(0,0);
                window.location.reload();
                return;
            }
        }

        try {
            setIsLoading(true);
            await post(`/api/products/subscriptions/${payload.currentOrLatestSubscriptionInfoId}/cancel`);
            if (currentSubscriptionProduct.afterCancellationPageUrl) {
                window.location.href = currentSubscriptionProduct.afterCancellationPageUrl;
            } else {
                window.location.reload();
            }
        } catch (ex) {
            catchErrorNoDispatch(ex, (error) => {
                dispatch(handleApiErrors(error));
                setErrors(error);
            })
            setIsLoading(false);
        }
    }

    const changeSubscription = async () => {
        if (!selectedSubscriptionProduct) {
            try {
                await post(
                '/api/flashmessage/add/', 
                { 
                    messageText: translate('js.myaccountflowsubscriptions.managesubscription.change.errortext'), 
                    messageType: "Pink", 
                    dismissible: true, 
                    timeToLive: 10 
                });
            } catch (ex) {
            } finally {
                window.scrollTo(0,0);
                window.location.reload();
                return;
            }
        }

        try {
            setIsLoading(true);
            const response = await post(
                `/api/products/subscriptions/${payload.currentOrLatestSubscriptionInfoId}/change`, 
                selectedSubscriptionProduct.productId);
            setShowAfterChangeMessage(true);
        } catch (ex) {
            catchErrorNoDispatch(ex, (error) => {
                dispatch(handleApiErrors(error));
                setErrors(error);
            })
        } finally {
            setRequestUserConfirmation(false);
            setIsLoading(false);
        }
    }

    const handleAfterChange = () => {
        window.location.reload();
    }
    
    const showSubscriptionControls = () => {
        return (
            <div className="form-radio-group my-account-flow-subscriptions__manage-subscription__controls">
                <InputField
                    id='cancelSubscriptionMode-change'
                    name='cancelSubscriptionMode-change'
                    type='radio'
                    value='false'
                    checked={!isInCancelSubscriptionMode}
                    label={translate('js.myaccountflowsubscriptions.managesubscription.change.modetext')}
                    onChange={() => setIsInCancelSubscriptionMode(false)}
                    errors={errors}
                />
                <InputField
                    id='cancelSubscriptionMode-cancel'
                    name='cancelSubscriptionMode-cancel'
                    type='radio'
                    value='true'
                    checked={isInCancelSubscriptionMode}
                    label={translate('js.myaccountflowsubscriptions.managesubscription.cancel.modetext')}
                    onChange={() => setIsInCancelSubscriptionMode(true)}
                    errors={errors}
                />
            </div>
        )
    }

    const showManageSubscriptionContent = () => {
        if (showAfterChangeMessage) {
            return (
                <Fragment>
                    <div 
                        className="my-account-flow-subscriptions__manage-subscription__change-box"
                        dangerouslySetInnerHTML={ {__html: payload.afterChangeMessage} }
                    >
                    </div>
                    <button onClick={handleAfterChange} className="button">
                        {translate('js.myaccountflowsubscriptions.managesubscription.change.after.buttontext')}
                    </button>
                </Fragment>
            )
        }

        return (
            <Fragment>
                <div className="my-account-flow-subscriptions__manage-subscription__change-box">
                    {payload.allSubscriptionProducts.map(product => (
                        <div 
                            onClick={() => setSelectedSubscriptionProduct(product)}
                            className={`my-account-flow-subscriptions__manage-subscription__change-box__item ${product.productId === selectedSubscriptionProduct.productId ? 'my-account-flow-subscriptions__manage-subscription__change-box__item--selected' : ''}`}
                            key={product.productId}
                            >
                            <div>
                                {product.productImageUrl && <img src={product.productImageUrl} alt={product.productName} />}
                            </div>
                            <div>
                                <h3>
                                    {product.productName && <span>{product.productName}</span>} {" "}
                                    {product.isCustomersCurrentSubscription && <span>{translate('js.myaccountflowsubscriptions.managesubscription.change.currentlysubscribing')}</span>}
                                </h3>
                                {product.productDescription && <div>{product.productDescription}</div>}
                            </div>
                            <div>
                                {product.isBestDeal && (
                                    <div className="my-account-flow-subscriptions__manage-subscription__change-box__item__best-deal-container">
                                        <i className="icon-savings"></i><span>{translate('js.myaccountflowsubscriptions.managesubscription.change.bestdealtext')}</span>
                                    </div>
                                )}
                                {product.formatedMonthlyPrice && <div>{product.formatedMonthlyPrice}</div>}
                            </div>
                        </div>
                    ))}
                    {!selectedSubscriptionProduct?.isCustomersCurrentSubscription && (
                        <div className="my-account-flow-subscriptions__manage-subscription__change-box__info">
                            <div>
                                {selectedSubscriptionProduct.isBestDeal 
                                    ? translate('js.myaccountflowsubscriptions.managesubscription.change.changeinfotext.upgrade.message')
                                    : translate('js.myaccountflowsubscriptions.managesubscription.change.changeinfotext.downgrade-sidegrade.message')
                                        .replace('{0}', payload.currentOrLatestSubscriptionNextPaymentDateFormatted)
                                }
                            </div>
                            {translate('js.myaccountflowsubscriptions.managesubscription.change.changeinfotext.date')}
                            <span className="my-account-flow-subscriptions__manage-subscription__change-box__info__bold">
                                {selectedSubscriptionProduct?.newPaymentDateFormatted}
                            </span>. {" "}
                            {translate('js.myaccountflowsubscriptions.managesubscription.change.changeinfotext.amount')}
                            <span className="my-account-flow-subscriptions__manage-subscription__change-box__info__bold">
                                {selectedSubscriptionProduct?.firstPaymentAmount}
                            </span>.
                        </div>
                    )}
                </div>
                {!selectedSubscriptionProduct.isCustomersCurrentSubscription ? (
                    <button
                        onClick={() => handleRequestUserConfirmation(changeSubscription)} 
                        className={`button ${isChanging ? 'loading' : ''}`} 
                        disabled={isChanging}>
                        <span>{translate('js.myaccountflowsubscriptions.managesubscription.change.buttontext')} {selectedSubscriptionProduct?.productName}</span>
                        <span className="spinner spinner--light spinner--small"></span>
                    </button>
                ) : (
                    <button onClick={onToggleManageSubscriptionMode} className="button">
                        {translate('js.myaccountflowsubscriptions.managesubscription.change.keep.buttontext')}
                    </button>
                )}
            </Fragment>
        )
    }

    const showCancelSubscriptionContent = () => {
        return (
            <Fragment>
                <div 
                    className="my-account-flow-subscriptions__manage-subscription__cancel-box"
                    dangerouslySetInnerHTML={ {__html: payload.cancelSubscriptionText } }
                >
                </div>
                <div className="my-account-flow-subscriptions__manage-subscription__footer">
                    {translate('js.myaccountflowsubscriptions.managesubscription.cancel.footertext')} {" "}
                    <span className="my-account-flow-subscriptions__manage-subscription__footer--bold">
                        {payload.currentOrLatestSubscriptionNextPaymentDateFormatted}
                    </span>
                </div>
                <div className="my-account-flow-subscriptions__manage-subscription__buttons">
                    <button onClick={() => handleRequestUserConfirmation(cancelSubscription, true)} className='button button__secondary'>
                        <span>{translate('js.myaccountflowsubscriptions.managesubscription.cancel.buttontext')}</span>
                    </button>
                    <button onClick={onToggleManageSubscriptionMode} className="button button__link">
                        {translate('js.myaccountflowsubscriptions.managesubscription.cancel.keep.buttontext')}
                    </button>
                </div>
            </Fragment>
        )
    }

    const showRequestUserConfirmationContent = () => {
        return (
            <div className='my-account-flow-subscriptions__manage-subscription__confirm'>
                <div className='my-account-flow-subscriptions__manage-subscription__confirm__buttons'>
                    {onConfirm?.isInCancelMode ? (
                        <Fragment>
                            <p>{translate('js.myaccountflowsubscriptions.userconfirmation.cancel.text')}</p>
                            <button 
                                onClick={() => onConfirm?.callback()} 
                                className={`button button__secondary ${isLoading ? 'loading' : ''}`} 
                                disabled={isLoading}
                            >
                                <span>{translate('js.myaccountflowsubscriptions.userconfirmation.cancel.button.confirm')}</span>
                                <span className="spinner spinner--light spinner--small"></span>
                            </button>
                        </Fragment>
                    ): (
                        <Fragment>
                            <p>{translate('js.myaccountflowsubscriptions.userconfirmation.change.text')}</p>
                            <button 
                                onClick={() => onConfirm?.callback()}
                                className={`button ${isLoading ? 'loading' : ''}`} 
                                disabled={isLoading}
                            >
                                <span>{translate('js.myaccountflowsubscriptions.userconfirmation.change.button.confirm')}</span>
                                <span className="spinner spinner--light spinner--small"></span>
                            </button>
                            
                        </Fragment>
                    )}
                    <button 
                        className='button button__link' 
                        onClick={handleCancelConfirm}
                        disabled={isLoading}>
                            {translate('js.myaccountflowsubscriptions.userconfirmation.button.cancel')}
                    </button>
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            <div className="my-account-flow-subscriptions__manage-subscription">

                {(!requestUserConfirmation && !showAfterChangeMessage) && (
                    <Fragment>
                        <h3>{payload.currentOrLatestSubscriptionProductName}</h3>
                        <div className="my-account-flow-subscriptions__manage-subscription__text">
                            {!isInCancelSubscriptionMode && payload.changeSubscriptionModeAllowed
                                ? <div dangerouslySetInnerHTML={ {__html: translate('js.myaccountflowsubscriptions.managesubscription.change.text') } } />
                                : <div dangerouslySetInnerHTML={ {__html: translate('js.myaccountflowsubscriptions.managesubscription.cancel.text') } } />
                            }
                        </div>
                    </Fragment>
                )}

                {requestUserConfirmation ? (
                    showRequestUserConfirmationContent()
                ) : (
                    <Fragment>
                        {(payload.changeSubscriptionModeAllowed && !showAfterChangeMessage) && showSubscriptionControls()}
                        {!isInCancelSubscriptionMode && payload.changeSubscriptionModeAllowed
                            ? showManageSubscriptionContent()
                            : showCancelSubscriptionContent()
                        }
                    </Fragment>
                )}

            </div>
        </Fragment>
    )
}

export default MyAccountMySubscriptionsManageSubScription;